// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Checkbox, NumberInput, Text } from '@mantine/core';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { IconAlertCircle } from '@tabler/icons';
import { i18n } from '@lingui/core';
import { openConfirmModal } from '@mantine/modals';
import PanePaper from '../../../Molecules/PanePaper';
import { ProfileContext } from '../../../Service/Context/ProfileContext';
import { EditableProfileProperty } from '../../../Atoms/EditableProperties/EditableProfileProperty';
import { EditableDivInput } from '../../../Atoms/inputs/EditableDivInput';
import { HtmlFormatter } from '../../../Atoms/Formatter/HtmlFormatter';
import BookitupAlert from '../../../Atoms/BookitupAlert';
import LinkText from '../../../Atoms/LinkText';
import { ValidationS } from '../../../Service/ValidationS';

const Taxes = () => {
  const navigate = useNavigate();
  const { profile, patchProfile } = useContext(ProfileContext);
  const { smallScaleBusiness, vat } = profile ?? {};

  const onCheckBoxChange = () => {
    const onConfirm = () => patchProfile({ smallScaleBusiness: !smallScaleBusiness });
    if (!smallScaleBusiness) {
      openConfirmModal({
        title: (
          <Text weight="bolder" size="xl">
            Vorlagen werden angepasst
          </Text>
        ),
        children: (
          <Text size="sm">
            Die Steuersätze werden in allen Dokument-Vorlagen entfernt. Bist Du sicher, dass du fortfahren möchtest?
          </Text>
        ),
        labels: { confirm: 'Bestätigen', cancel: 'Abbrechen' },
        onConfirm,
      });
    } else {
      onConfirm();
    }
  };

  return (
    <PanePaper title="settings.taxes" tooltip="help.settings.taxes.pane" sx={{ maxWidth: 600 }}>
      <BookitupAlert icon={<IconAlertCircle />}>
        <Text>
          Wenn du den allgemeinen Mehrwertsteuersatz änderst, bekommen alle Positionen in den Dokumentvorlagen den neuen
          Satz, die vorher den alten allgemeinen Mehrwertsteuersatz hatten. Wir empfehlen dir daher, alle Preise in den{' '}
          <LinkText span onClick={() => navigate('/settings/templates')}>
            Dokumentvorlagen
          </LinkText>{' '}
          zu überprüfen und gegebenenfalls anzupassen.
        </Text>
      </BookitupAlert>
      <NumberInput
        hideControls
        removeTrailingZeros
        disabled={smallScaleBusiness}
        mt="md"
        label="MwSt.-Satz"
        decimalSeparator=","
        precision={2}
        defaultValue={vat}
        min={0}
        max={100}
        sx={{ maxWidth: 200 }}
        onBlur={(e) => {
          const { value } = e.currentTarget;
          patchProfile({ vat: ValidationS.isValuePresent(value) ? parseFloat(value.replace(',', '.')) : 0 });
        }}
        rightSection={
          <Text pr="xs" weight="bolder">
            %
          </Text>
        }
      />
      <Text mt={5} color="dimmed">
        Hinweis: Du kannst den MwSt.-Satz auch individuell für jede Position im Dokument einstellen.
      </Text>
      <Checkbox
        my="md"
        onChange={onCheckBoxChange}
        checked={smallScaleBusiness}
        label={i18n._('profile.smallScaleBusiness')}
      />
      {smallScaleBusiness && (
        <EditableProfileProperty
          patchField="vatStatement"
          profile={profile}
          placeholder="profile.vatStatement"
          editFormatter={EditableDivInput}
          labelFormatter={HtmlFormatter}
          preChange={undefined}
        />
      )}
    </PanePaper>
  );
};

export default Taxes;
